/**
 * @author 3173
 * @description 列表
 * @Date 2020/9/25
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '../../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let { WizBrowserExport, WizCard, WizRow, WizCol } = component_tool;
let {Session} = utils_tool

class SeriesContentList extends WizContainer {

  componentName = 'seriesContentList';

  constructor(props) {
    super(props);
    const {history} = props
    let initialValue = {}
    if (history.location && history.location.pathname === '/series/seriesList/seriesContentList') {
      if (history.location && history.location.record && history.location.record.id) {
        initialValue = history.location.record
        Session.set('seriesInfo', initialValue)
      } else {
        initialValue = Session.get('seriesInfo') || {}
      }
    } else if(history.location && history.location.pathname === '/trainPath/seriesContentList') {
      if (history.location && history.location.record && history.location.record.id) {
        initialValue = history.location.record
        Session.set('trainPathSeriesInfo', initialValue)
      } else {
        initialValue = Session.get('trainPathSeriesInfo') || {}
      }
    } else {
      initialValue = Session.get('seriesInfo') || {}
    }
    this.state = {

    }
    this.initialValue = initialValue
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['name'] = checkStrLength(val['name'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '课程名称',
        field: 'programName',
        width: 45,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '分类',
        field: 'categoryName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联时间',
        field: 'relationTime',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'stateStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },

    ]
    if (o['success']) {
      let data = o['data']
      let sName = ''
      data.forEach(e=>{
        e.state ? '有效' : '无效';
        sName = ':'+ e.seriesName;
      })

      WizBrowserExport({
        title: '系列化课程内容信息' + sName,
        sheetName: '系列化课程内容信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '系列化课程内容信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _render() {
    let treeDateId = this.initialValue.categoryId;
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this.initialValue),
      apiDataFormat: {
        add: this._handleCMD,
        export: this._handleFile,
        updateStatus:this._handleCMD
      },
      treeDateId: treeDateId,
      seriesId: this.initialValue.id,
      time: new Date().getTime()

    })
    return (
      <>
        <WizCard title={'系列化课程信息'}>
          <WizRow>
            <WizCol span={12} push={2}>
              <span className="ant-table-column-title" style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: 500 }}>系列化课程名称:</span>
              <span className="ant-table-row-cell-break-word" > {this.initialValue.name}</span>
            </WizCol>
          </WizRow>
        </WizCard>
        <WizCard title={'内容管理'}>
          <WizReduxTemplate {..._reduxTemplateCofig} />
        </WizCard>
      </>
    )

  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(SeriesContentList);
